export const ApiSettingsSmtp = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const save = async (payload) => {
    const result = await axios.post('/api/settings/smtp', JSON.parse(payload))
    return result.data
  }

  const undo = async (payload) => {
    const result = await axios.post('/api/settings/smtp/undo', payload)
    return result.data
  }

  const test = async () => {
    try {
      const result = await axios.post('/api/settings/smtp/test')
      return result.data
    } catch (error) {
      return Promise.reject(error)
    }
  }

  const load = async () => {
    const result = await axios.get('/api/settings/smtp')
    return result.data
  }

  return {
    smtpLoad: load,
    smtpSave: save,
    smtpTest: test,
    smtpUndo: undo
  }
}
